import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFlagUkGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M26.41 13H8v22h32V13H26.41Zm0 1.179h10.988L26.41 21.643v-7.464Zm-4.82 0v7.464l-11.47-7.464h11.47Zm-12.433.883 10.698 6.974H9.157v-6.974Zm0 11.884h9.445l-9.349 6.286v-6.286h-.096Zm12.433 6.777H10.602l10.12-6.875h.868v6.875Zm4.82 0v-6.875h.963l10.506 6.875H26.41Zm12.433-.785-9.156-5.992h9.156v5.991Zm0-7.268h-13.59v8.053h-2.41V25.67H9.157v-2.456h13.686V14.18h2.41v9.035h13.59v2.456Zm0-3.634H27.952l10.891-7.268v7.268Z",
    fill: "currentColor"
  }));
}

export { SvgFlagUkGlyph as default };
